import React from "react";
import {useSelector} from "react-redux";
import {getBackground} from "../../../store/slices/productFinder";
import DotsBackground from "./DotsBackground";
import HomeBackground from "./HomeBackground";
import WhereBackground from "./WhereBackground";
import DistanceBackground from "./DistanceBackground";
import TimesBackground from "./TimesBackground";
import DurationBackground from "./DurationBackground";
import ResultBackground from "./ResultBackground";

const Background = () => {

    const background = useSelector(getBackground);


    const getBackgroundComponent = (b) => {
        switch (b) {
            case 'home':
                return <HomeBackground />
            case 'dots':
                return <DotsBackground />
            case 'where':
                return <WhereBackground />
            case 'distance':
                return <DistanceBackground />
            case 'times':
                return <TimesBackground />
            case 'duration':
                return <DurationBackground />
            case 'result':
                return <ResultBackground />
            default:
                return <DotsBackground />
        }
    }


    return (
        <div
            className={`product-finder-background product-finder-background__${background}`}
        >
            { getBackgroundComponent(background) }
        </div>
    )

}

export default Background;
